export enum Routes {
  Admin = '/admin',
  AdminFeatureFlags = '/admin/feature-flags',
  AdminDevicesListing = '/admin/devices',
  AdminDevicesBridges = '/admin/bridges',
  AdminDevicesBridgesDeploy = '/admin/bridges/deploy',
  AdminDevicesListingConfirmation = '/admin/devices/confirmation',
  AdminOrganization = '/admin/organizations/$organizationId',
  AdminOrganizationEdit = '/admin/organizations/$organizationId/edit',
  AdminUser = '/admin/users/$userId',
  AdminUserEdit = '/admin/users/$userId/edit',
  AdminDeviceDecom = '/admin/device-decom',
  AdminDevicesPricingChange = '/admin/devices/pricing',
  AdminDevicesBulkEndRental = '/admin/devices/bulk-end-rental',
  AdminDevicesDecommission = '/admin/devices/decom',
  AdminUsersOrgsSearch = '/admin/users-orgs/search',
  AdminUsersOrgsManage = '/admin/users-orgs/manage',
  AdminReservationInvites = '/admin/reservations/invites',
  AdminCreateReservationInvite = '/admin/reservations/invites/create',
  AdminDeleteReservationInvite = '/admin/reservations/invites/delete',
  AdminEditReservationInvite = '/admin/reservations/invites/$inviteId/edit',
  AdminReservationManager = '/admin/reservations/manage',
  AdminEditReservation = '/admin/reservations/manage/$reservationId/edit',
  AdminStripeOrphans = '/admin/reservations/stripe-orphans',
  AdminStripeOrphansLinkReservation = '/admin/reservations/stripe-orphans/$stripeSubscriptionId/link-reservation',
  AdminDeleteOrganization = '/admin/users-orgs/manage/organization/$organizationId/delete',
  AdminMarkOrganizationTrusted = '/admin/users-orgs/manage/organization/$organizationId/confirm',
  AdminDeviceOverview = '/admin/devices/$deviceId/overview',
  AdminDeviceProvision = '/admin/devices/$deviceId/provision',
  AdminDeviceProvisionAddSshKey = '/admin/devices/$deviceId/provision/add-sshkey',
  AdminDeviceDecommission = '/admin/devices/$deviceId/decommission',
  AdminDeviceDeprecate = '/admin/devices/$deviceId/deprecate',
  AdminDeviceReOnboard = '/admin/devices/$deviceId/re-onboard',
  AdminDeviceReprovision = '/admin/devices/$deviceId/reprovision',
  AdminDeviceReprovisionConfirmation = '/admin/devices/$deviceId/reprovision/confirmation',
  AdminDevicePowerControl = '/admin/devices/$deviceId/power-control',
  AdminDevicePowerControlReboot = '/admin/devices/$deviceId/power-control/reboot',
  AdminDevicePowerControlPowerOff = '/admin/devices/$deviceId/power-control/off',
  AdminDevicePowerControlPowerOn = '/admin/devices/$deviceId/power-control/on',
  AdminDeviceReboot = '/admin/devices/$deviceId/reboot',
  AdminDeviceRebootConfirmation = '/admin/devices/$deviceId/reboot/confirmation',
  AdminDeviceEndRental = '/admin/devices/$deviceId/end-rental',
  AdminDeviceIpam = '/admin/devices/$deviceId/ipam',
  AdminDeviceIpamInterface = '/admin/devices/$deviceId/ipam/$interfaceId',
  AdminDeviceIpamInterfaceAssign = '/admin/devices/$deviceId/ipam/$interfaceId/assign',
  AdminDeviceIpamInterfaceEdit = '/admin/devices/$deviceId/ipam/$interfaceId/edit',
  AdminDeviceNetplan = '/admin/devices/$deviceId/netplan',
  AdminZoneRequests = '/admin/zone-requests',
  AdminDeviceDiagnostics = '/admin/devices/$deviceId/diagnostics',
  AdminZoneRequest = '/admin/zone-requests/$requestId',
  Unauthorized = '/unauthorized',
  NotFound = '/notfound',

  HelpdeskNewTicket = '/helpdesk/new-ticket',
  HelpdeskTickets = '/helpdesk/tickets',
  HelpdeskTicket = '/helpdesk/tickets/$ticketId',

  DcimSites = '/dcim/sites',
  DcimSitesCreate = '/dcim/sites/create',
  DcimSitesSite = '/dcim/$organizationId/sites/$siteId',
  DcimSitesSiteEdit = '/dcim/$organizationId/sites/$siteId/edit',
  DcimSitesSiteAddressPrimaryEdit = '/dcim/$organizationId/sites/$siteId/address-primary/edit',
  DcimSitesSiteAddressShippingEdit = '/dcim/$organizationId/sites/$siteId/address-shipping/edit',
  DcimSitesSiteContactsCreate = '/dcim/$organizationId/sites/$siteId/contacts/create',
  DcimSitesSiteContactsContactDelete = '/dcim/$organizationId/sites/$siteId/contacts/$contactId/delete',
  DcimSitesSiteContactsContactEdit = '/dcim/$organizationId/sites/$siteId/contacts/$contactId/edit',
  DcimSitesSiteZonesZone = '/dcim/$organizationId/sites/$siteId/zones/$zoneId',
  DcimSitesSiteZoneRequestsCreate = '/dcim/$organizationId/sites/$siteId/zone-requests/create',
  DcimSitesSiteZoneRequestsZoneRequest = '/dcim/$organizationId/sites/$siteId/zone-requests/$zoneRequestId',
  DcimSitesSiteZoneRequestsZoneRequestDelete = '/dcim/$organizationId/sites/$siteId/zone-requests/$zoneRequestId/delete',
  DcimSitesSiteZoneRequestsZoneRequestEdit = '/dcim/$organizationId/sites/$siteId/zone-requests/$zoneRequestId/edit',

  DcimDevices = '/dcim/devices',
  DcimDevicesDevice = '/dcim/devices/$deviceId',
  DcimDevicesDeviceNetworking = '/dcim/$organizationId/devices/$deviceId/networking',
  DcimDevicesDeviceNetworkingEdit = '/dcim/$organizationId/devices/$deviceId/networking/edit',
  DcimDevicesDeviceOverview = '/dcim/$organizationId/devices/$deviceId/overview',
  DcimDevicesDeviceProvision = '/dcim/$organizationId/devices/$deviceId/provision',
  DcimDevicesDeviceProvisionAddSshKey = '/dcim/$organizationId/devices/$deviceId/provision/add-sshkey',
  DcimDevicesDeviceDeprecate = '/dcim/$organizationId/devices/$deviceId/deprecate',
  DcimDevicesDeviceReOnboard = '/dcim/$organizationId/devices/$deviceId/re-onboard',
  DcimDevicesDevicesSettings = '/dcim/$organizationId/devices/$deviceId/settings',
  DcimStorefronts = '/dcim/storefronts',
  DcimDevicesListing = '/dcim/devices',
  DcimDevicesListingConfirmation = '/dcim/devices/listing/confirmation',
  DcimDevicesPricingChange = '/dcim/devices/pricing',

  Deployments = '/deployments',
  DeploymentsDeviceConnect = '/deployments/$deviceId/connect',
  DeploymentsDeviceOverview = '/deployments/$deviceId/overview',
  DeploymentsDeviceReprovision = '/deployments/$deviceId/reprovision',
  DeploymentsDevicePowerControl = '/deployments/$deviceId/power-control',
  DeploymentsDevicePowerControlOn = '/deployments/$deviceId/power-control/on',
  DeploymentsDevicePowerControlOff = '/deployments/$deviceId/power-control/off',
  DeploymentsDevicePowerControlReboot = '/deployments/$deviceId/power-control/reboot',
  DeploymentsDeviceReprovisionAddSshKey = '/deployments/$deviceId/reprovision/add-sshkey',
  DeploymentsDeviceReprovisionConfirmation = '/deployments/$deviceId/reprovision/confirmation',
  DeploymentsDeviceSettings = '/deployments/$deviceId/settings',
  DeploymentsDeviceActionLog = '/deployments/$deviceId/action-log',

  DocsBrokkrOverview = '/docs/brokkr-overview',
  DocsBrokkrComponents = '/docs/brokkr-components',
  DocsBrokkrTermsOfService = '/docs/brokkr-tos',
  DocsBrokkrApiOverview = '/docs/brokkr-api-overview',
  DocsBrokkrApiAuthentication = '/docs/brokkr-api-authentication',
  DocsBrokkrApiDcim = '/docs/brokkr-api-dcim',
  DocsBrokkrApiDeployments = '/docs/brokkr-api-deployments',
  DocsBrokkrApiInventory = '/docs/brokkr-api-inventory',
  DocsBrokkrApiReservations = '/docs/brokkr-api-reservations',
  DocsBrokkrBridgeInstallationOverview = '/docs/installation-overview',
  DocsBrokkrSecurityBrokkrSecurityDocumentation = '/docs/brokkr-security',
  DocsBrokkrSecurityMfa = '/docs/brokkr-mfa',
  DocsBrokkrFaqSshStopsOnVpn = '/docs/ssh-stops-on-vpn',
  DocsBrokkrFaqNvidiaSmiNotWorking = '/docs/nvidia-smi-not-working',
  DocsBrokkrFaqSshKeysWithBrokkr = '/docs/ssh-keys-with-brokkr',
  DocsBrokkrFaqNvidiaDriverAndCudaToolkit = '/docs/nvidia-driver-and-cuda-toolkit',

  Error = '/error',

  Login = '/login',
  Logout = '/logout',
  SignUp = '/signup',
  SetupTwoFactor = '/mfa/setup',
  ConfirmTwoFactor = '/mfa/confirm',
  PhoneNumberTwoFactorSetup = '/mfa/phone-number/setup',
  PhoneNumberTwoFactorConfirmation = '/mfa/phone-number/confirm',
  ResetMfaByPhoneCodeConfirmation = '/mfa/reset-mfa-by-phone-code/confirm',
  ForgotPassword = '/forgot-password',
  NewPassword = '/new-password/$code',
  SetupAccount = '/setup-account',

  Inventory = '/inventory/category',
  InventoryCategory = '/inventory/categories/$category',
  InventoryDevice = '/inventory/$deviceId',
  InventoryDeviceCheckout = '/inventory/$deviceId/checkout',
  PublicInventory = '/public/inventory/category',
  PublicInventoryCategory = '/public/inventory/categories/$category',

  OnboardingOrganizationMembership = '/onboarding/organization-membership',

  OrganizationsApiKeys = '/organizations/$organizationId/api-keys',
  OrganizationsApiKeysCreate = '/organizations/$organizationId/api-keys/create',
  OrganizationsApiKeysDelete = '/organizations/$organizationId/api-keys/$apiKeyId/delete',
  OrganizationsBilling = '/organizations/$organizationId/billing',
  OrganizationsBillingPaymentMethodAdd = '/organizations/$organizationId/billing/payment-methods/add',
  OrganizationsBillingPaymentMethodDefault = '/organizations/$organizationId/billing/payment-methods/$paymentMethodId/default',
  OrganizationsCreate = '/organizations/create',
  OrganizationsMembers = '/organizations/$organizationId/members',
  OrganizationsSettings = '/organizations/$organizationId/settings',

  ResourceValidateEmail = '/resource/validate-email',

  SettingsSshKeys = '/settings/sshkeys',
  SettingsSshKeysCreate = '/settings/sshkeys/create',
  SettingsSshKeysDelete = '/settings/sshkeys/$sshKeyId/delete',

  SettingsUser = '/settings/user',
  SettingsUserEdit = '/settings/user/edit',
}

type RouteParams = {
  [key: string]: string | number | undefined;
};

export function withParams(
  route: Routes | string,
  params: RouteParams,
): string {
  let result = route;

  for (const [key, value] of Object.entries(params)) {
    result = result.replace(`$${key}`, value?.toString() || '');
  }

  return result;
}
